import Menu from './Menu'

const MenuExpand = (itemOne, itemTwo) => {
    const handleToggle = (expanded, e) => {
        console.log('expanded', expanded)
        console.log('event', e)
    }

    return (
        <Menu>
            <Menu.MenuCollapse
                eventKey="item-1"
                label={itemOne}
                onToggle={handleToggle}
            >
                <Menu.MenuItem eventKey="item-1-1">Item 1.1</Menu.MenuItem>
            </Menu.MenuCollapse>

            <Menu.MenuCollapse
                eventKey="item-2"
                label={itemTwo}
                onToggle={handleToggle}
            >
                <Menu.MenuItem eventKey="item-2-1">Item 2.1</Menu.MenuItem>
            </Menu.MenuCollapse>
            
        </Menu>
    )
}

export default MenuExpand


